function isUnset(v) {
  return v === '' || v === null || v === undefined || v === 'null'
}

/**
 * True when the customer is in the Fintos advisory pool or was explicitly sent to Fintos advisory.
 * Do not use send_to_advisory here — that timestamp may reflect affiliate / bulk advisory flows.
 */
export function isFintosAdvisoryPoolCustomer(customer) {
  if (!customer) return false
  if (customer.is_fintos_advisory_pool === true) return true
  return !isUnset(customer.sent_to_fintos_advisory_at)
}

/**
 * Generic advisory pipeline (affiliate/bulk/Fintos): show advisory tooling when any path is active.
 */
export function customerHasAdvisoryPipeline(customer) {
  if (!customer) return false
  if (!isUnset(customer.send_to_advisory)) return true
  return isFintosAdvisoryPoolCustomer(customer)
}

/** Loan/customer listing: warn admins when advisory is active but SSA is missing. */
export function advisoryListingNeedsSsaWarning(customer) {
  if (!customer || customer.ssa) return false
  return customerHasAdvisoryPipeline(customer)
}
